import { render, staticRenderFns } from "./alexa-callback.vue?vue&type=template&id=4602fae0&scoped=true"
import script from "./alexa-callback.vue?vue&type=script&lang=js"
export * from "./alexa-callback.vue?vue&type=script&lang=js"
import style0 from "./alexa-callback.vue?vue&type=style&index=0&id=4602fae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4602fae0",
  null
  
)

export default component.exports